import { ReactNode } from "react";

type Props = {
  title: string;
  children: ReactNode;
};
export default function BidLimitContent({ title, children }: Props) {
  return (
    <div className="flex flex-col items-center gap-[10px]">
      <div className="font-semibold">{title}</div>
      {children}
    </div>
  );
}
